import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'core/context/TranslationContext';

const LanguageDropdown = () => {
  const { languages, currentLanguage, changeLanguage, _t, isRTL } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLanguageChange = (language) => {
    changeLanguage(language);
    setIsOpen(false);
  };

  if (!languages || languages.length === 0) {
    return null;
  }

  return (
    <div className="language-dropdown" ref={dropdownRef} style={{ position: 'relative' }}>
      <button
        className="language-dropdown-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Change language"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          padding: '5px 10px',
          border: '1px solid #e8e8e8',
          borderRadius: '8px',
          background: 'white',
          cursor: 'pointer',
          fontSize: '12px',
          fontWeight: 500,
          transition: 'all 0.2s'
        }}
        onMouseEnter={(e) => e.target.style.borderColor = '#007bff'}
        onMouseLeave={(e) => e.target.style.borderColor = '#e0e0e0'}
      >
        {currentLanguage?.icon && (
          <span 
            className="language-icon"
            dangerouslySetInnerHTML={{ __html: currentLanguage.icon }}
            style={{ display: 'inline-flex', alignItems: 'center' }}
          />
        )}
        {currentLanguage?.material_io && (
          <i className={`material-icons`} style={{ fontSize: '16px' }}>
            {currentLanguage.material_io}
          </i>
        )}
        <span className="language-abbreviation" style={{ fontWeight: 500 }}>
          {currentLanguage?.abbreviation?.toUpperCase() || 'EN'}
        </span>
        <svg
          width="10"
          height="10"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s'
          }}
        >
          <path
            d="M6 9L1 4H11L6 9Z"
            fill="currentColor"
          />
        </svg>
      </button>

      {isOpen && (
        <div
          className="language-dropdown-menu"
          style={{
            position: 'absolute',
            top: '100%',
            [isRTL ? 'left' : 'right']: 0,
            marginTop: '4px',
            background: 'white',
            border: '1px solid #e0e0e0',
            borderRadius: '4px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            zIndex: 1000,
            minWidth: '150px',
            maxHeight: '300px',
            overflowY: 'auto'
          }}
        >
          {languages.map((language) => (
            <button
              key={language.id}
              onClick={() => handleLanguageChange(language)}
              className={`language-option ${currentLanguage?.id === language.id ? 'active' : ''}`}
              style={{
                width: '100%',
                padding: '8px 10px',
                border: 'none',
                background: currentLanguage?.id === language.id ? '#f0f0f0' : 'white',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '13px',
                textAlign: isRTL ? 'right' : 'left',
                flexDirection: isRTL ? 'row-reverse' : 'row',
                transition: 'background 0.2s'
              }}
              onMouseEnter={(e) => {
                if (currentLanguage?.id !== language.id) {
                  e.target.style.background = '#f8f8f8';
                }
              }}
              onMouseLeave={(e) => {
                if (currentLanguage?.id !== language.id) {
                  e.target.style.background = 'white';
                }
              }}
            >
              {language.icon && (
                <span
                  className="language-icon"
                  dangerouslySetInnerHTML={{ __html: language.icon }}
                  style={{ display: 'inline-flex', alignItems: 'center' }}
                />
              )}
              {language.material_io && (
                <i className="material-icons" style={{ fontSize: '16px' }}>
                  {language.material_io}
                </i>
              )}
              <span style={{ flex: 1 }}>{language.name}</span>
              <span style={{ fontSize: '12px', color: '#666' }}>
                {language.abbreviation?.toUpperCase()}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageDropdown;

